module.exports = __webpack_public_path__ + "static/media/document.96c0211a.svg";